import { ref, computed, watch, resolveComponent, createElementBlock, openBlock, Fragment, createVNode, unref, withCtx } from "vue";
import { useApolloGlobalClient } from "../../../plugins/apollo.js";
import { cloneDeep } from "lodash-es";
import { difference } from "../../../utils/difference.js";
import "../../../constants/UserPolicy.js";
import "pinia";
import "../../../store/index.js";
import { useBanza } from "../../../plugins/banza/global.js";
import "axios";
import "vue-router";
import { useI18n } from "../../../plugins/i18n.js";
import "maska";
import { ROLES_LOOKUP } from "../../../graphql/queries.js";
import "../../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../../assets/3448554beb4b633a.svg";
import "../../../plugins/banza/img.js";
import "vuetify/components/VImg";
import "../../../constants/components/index.js";
/* empty css                            */
import "vuetify/components/VDialog";
import { ADD_OR_EDIT_POLICY } from "../../../graphql/mutations.js";
import Swal from "sweetalert2";
import "@vee-validate/i18n";
/* empty css                           */
import { VCardActions } from "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                     */
import { VDivider } from "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../../assets/8a32dc557a826bf0.png";
/* empty css                        */
import "../../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                    */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../../Auth/AppleAuthButton/AppleAuthButton.js";
import "../../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                                  */
import { VSpacer } from "vuetify/components/VGrid";
import "../../Base/index.js";
import "moment";
import "vuex";
/* empty css                           */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../../icons/mdi/index.js";
/* empty css                               */
import "vuetify/components/VBtnToggle";
import "../../../assets/6f5dc1ff0a697731.svg";
import "../../../assets/888bb8db73be3c15.svg";
/* empty css                                */
import "vuetify/components/VInfiniteScroll";
/* empty css                                     */
/* empty css                         */
import "vuetify/components/VChip";
/* empty css                             */
import "../../HtmlEditor/index.js";
import "../../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                                  */
/* empty css                           */
import "../../News/NewsModule/NewsModule.vue.js";
import "../../News/NewsModule/NewsList.vue.js";
import "../../../graphql/news.js";
/* empty css                           */
import "../../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                    */
import "vuetify/components/VWindow";
import "../../../assets/5a0af7dd23957928.png";
import "tiny-emitter/instance";
import "../../../graphql/system-settings.js";
/* empty css                                */
/* empty css                                       */
import "vuetify/components/VHover";
import "../../../constants/NewsGroup.js";
/* empty css                                        */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                      */
import "vuetify/components/VBottomSheet";
import "../../../graphql/favorites.js";
import "../../../plugins/tracker/page-tracker.js";
/* empty css                                */
import "../../../graphql/notifications.js";
/* empty css                                     */
import "../../../constants/CommunicationChannels.js";
/* empty css                               */
import "vuetify/components/VColorPicker";
/* empty css                                                   */
import "vuetify/components/VTextarea";
/* empty css                               */
import "vuetify/components/VTooltip";
/* empty css                                                */
/* empty css                             */
import "graphql-tag";
import "../../../graphql/lookups.js";
import "../../../graphql/entity.js";
/* empty css                          */
import "vuetify/components";
/* empty css                                */
/* empty css                        */
import "../../../graphql/system-events.js";
/* empty css                                           */
/* empty css                            */
/* empty css                            */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css              */
/* empty css                            */
import "vuetify/components/VAlert";
/* empty css                 */
import "vue-dndrop";
/* empty css                                               */
/* empty css                                       */
import "vue-advanced-cropper";
import "../../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                           */
import "vuetify/components/VFileInput";
/* empty css                               */
import "vuetify/components/VAvatar";
/* empty css                                     */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                                 */
import "../../../graphql/public-articles.js";
/* empty css                                              */
/* empty css                                  */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                     */
import "vuetify/components/VItemGroup";
/* empty css                                */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                           */
import "../../../graphql/quartz.js";
import "vue-i18n";
import "../../../graphql/integration-systems.js";
import "../../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                         */
/* empty css                                       */
import "../../../graphql/session-store.js";
import "../../../composables/useModalPage.js";
import "../../../icons/portal/index.js";
const _sfc_main = {
  __name: "OperationsSectionExpandedRow",
  props: {
    modelValue: Object
  },
  emits: ["close", "update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { t } = useI18n();
    const client = useApolloGlobalClient();
    const banza = useBanza();
    const editedItem = ref(cloneDeep(props.modelValue));
    const newRoles = computed(() => {
      var _a, _b;
      return ((_b = (_a = editedItem.value) == null ? void 0 : _a.roles) == null ? void 0 : _b.filter(
        (x) => {
          var _a2, _b2;
          return !x.isDeleted && !((_b2 = (_a2 = props.modelValue) == null ? void 0 : _a2.roles) == null ? void 0 : _b2.some((r) => r.id === x.id));
        }
      )) || [];
    });
    const deletedRoles = computed(() => {
      var _a, _b;
      return ((_b = (_a = props.modelValue) == null ? void 0 : _a.roles) == null ? void 0 : _b.filter(
        (x) => {
          var _a2, _b2;
          return !((_b2 = (_a2 = editedItem.value) == null ? void 0 : _a2.roles) == null ? void 0 : _b2.some(
            (r) => r.id === x.id && !r.isDeleted
          ));
        }
      )) || [];
    });
    const close = () => {
      emit("close");
    };
    const saveEditable = async () => {
      var _a;
      let text = `${t("components.users.messages.operation_role_changing")} ${editedItem.value.name}?`;
      if (newRoles.value.length > 0) {
        text += `<br>${t("components.users.messages.role_new")} ${newRoles.value.map((r) => r.name).join(", ")}.`;
      }
      if (deletedRoles.value.length > 0) {
        text += `<br>${t(
          "components.users.messages.role_delete"
        )} ${deletedRoles.value.map((r) => r.name).join(", ")}.`;
      }
      const result = await Swal.fire({
        title: text,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("base.yes"),
        cancelButtonText: t("base.buttons.cancel")
      });
      if (!result.isConfirmed) {
        close();
        return;
      }
      const changedData = difference(editedItem.value, props.modelValue);
      if (deletedRoles.value.length > 0) {
        changedData.roles = (changedData.roles || []).concat(
          deletedRoles.value.map((r) => ({ id: r.id, isDeleted: true }))
        );
      }
      if (!((_a = changedData.roles) == null ? void 0 : _a.length)) {
        return;
      }
      changedData.id = props.modelValue.id;
      banza.showGlobalLoader(true);
      await client.mutate({
        mutation: ADD_OR_EDIT_POLICY,
        variables: {
          input: changedData
        }
      });
      banza.hideGlobalLoader();
      editedItem.value.roles = editedItem.value.roles.filter((r) => !r.isDeleted);
      emit("update:modelValue", cloneDeep(editedItem.value));
      close();
    };
    watch(
      () => props.modelValue,
      (newValue) => {
        editedItem.value = cloneDeep(newValue);
      }
    );
    return (_ctx, _cache) => {
      const _component_b_autocomplete = resolveComponent("b-autocomplete");
      const _component_b_btn = resolveComponent("b-btn");
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(_component_b_autocomplete, {
          modelValue: editedItem.value.roles,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => editedItem.value.roles = $event),
          label: _ctx.$t("base.labels.roles"),
          query: unref(ROLES_LOOKUP),
          "prepend-icon": "mdi-account-group",
          multiple: "",
          chips: "",
          "closable-chips": "",
          "select-mode": "",
          clearable: "",
          "items-result-path": "roles",
          color: "primary",
          class: "ma-3"
        }, null, 8, ["modelValue", "label", "query"]),
        createVNode(VDivider),
        createVNode(VCardActions, { class: "pa-3 g-2" }, {
          default: withCtx(() => [
            createVNode(VSpacer),
            createVNode(_component_b_btn, {
              onClick: saveEditable,
              preset: "save",
              disabled: !newRoles.value.length && !deletedRoles.value.length
            }, null, 8, ["disabled"]),
            createVNode(_component_b_btn, {
              onClick: close,
              preset: "cancel"
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
